import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { RequestResponse } from "../model/dto/RequestResponse";
import { Organization } from "../model/Organization";
import { Tenant } from "../model/Tenant";

@Injectable()
export class TenantFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetTenantByEmail(email: string): Observable<RequestResponse<Tenant[]>> {
        return this._httpClient.get<RequestResponse<Tenant[]>>(this._urlBase + 'api/Tenant?email=' + email);
    }

    GetAll(): Observable<any> {
        return this._httpClient.get<any>(this._urlBase + 'api/Tenant/All');
    }

}